import { ShieldAlert } from "lucide-react";

export const AdminViewBanner = () => (
  <div className="flex items-center gap-3 bg-amber-50 border-b border-amber-200 px-4 py-2.5 text-sm text-amber-900">
    <ShieldAlert className="h-4 w-4 shrink-0 text-amber-600" />
    <span className="font-medium">Read-only admin view</span>
    <span className="text-amber-700">
      — You are viewing this gym as an admin. No changes can be made.
      Refreshing the page will end this session.
    </span>
  </div>
);
